<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">
                {{ $t("RESELLER_PRODUCTS.RESELLER_PRODUCTS_LIST") }}
              </h3>
            </div>
            <div class="col-6 text-right">
              <base-button
                type="primary"
                icon
                size="sm"
                @click="addResellerProduct()"
                v-if="
                  $currentUserCan($permissions.PERM_CREATE_RESELLER_PRODUCTS)
                "
              >
                <span class="btn-inner--icon">
                  <i class="fas fa-plus"></i>
                </span>
                <span class="btn-inner--text">
                  {{ $t("RESELLER_PRODUCTS.ADD_RESELLER_PRODUCT") }}
                </span>
              </base-button>

              <notification-subscription
                v-if="$currentUserCan($permissions.PERM_VIEW_RESELLER_PRODUCTS)"
                :objectType="'reseller-products'"
                :events="{
                  CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>

        <reseller-product-list-table />
      </card>
    </div>
  </div>
</template>
<script>
import { Button } from "element-ui";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import ResellerProductListTable from "./partials/ResellerProductListTable.vue";

export default {
  layout: "DashboardLayout",

  components: {
    ResellerProductListTable,
    NotificationSubscription,
    [Button.name]: Button,
  },

  mixins: [],

  computed: {},

  watch: {},

  methods: {
    addResellerProduct() {
      this.$router.push({ name: "Add ResellerProduct" });
    },
  },
};
</script>
